import React from 'react';

import { hasOverlap } from '../../components/PageLayout/utils';
import { UserGroup } from '../../types/common';
import useUserGroups from '../../utils/react/hooks/useUserGroups';

import StaffTutorialsPage from './StaffTutorialsPage';
import StudentTutorialsPage from './StudentTutorialsPage';

const TutorialsPage = () => {
  const userGroups = useUserGroups();

  if (userGroups?.includes(UserGroup.Students)) {
    return (
      <StudentTutorialsPage />
    );
  }

  if (userGroups && hasOverlap(userGroups, [UserGroup.Admins, UserGroup.Teachers])) {
    return (
      <StaffTutorialsPage userGroups={userGroups} />
    );
  }

  return <div />;
};
export default TutorialsPage;
